module.exports = __webpack_public_path__ + "img/search-icon.81d9d3c1.svg";